import { setGameWindowContext } from '@/store/actions.ts';
import XButton from '@/features/Icons/XButton';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';

const CloseGameWindowButton = ({ size }: { size?: number }) => {
  const { emitClientEvent } = useEventManagerEmitter();

  const handleCloseMenu = () => {
    emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.AUTO_SPIN_RESUME);
    setGameWindowContext({ gameWindowOpen: false });
  };

  return (
    <div
      className="close-icon"
      style={{ cursor: 'pointer' }}
      data-testid="close-game-window-button"
      onClick={handleCloseMenu}
    >
      <XButton color="white" size={size} strokeWidth="2" />
    </div>
  );
};

export default CloseGameWindowButton;
